module.exports = __webpack_public_path__ + "img/lens-150-minus-03.f3318ad4.png";